import { IdEnums } from '@nhl/nhl-breakaway-ui';

import { ClubStats } from './types';

export const didTeamPlayGamesOfThisType = (
    selectedGameType: IdEnums.GameType,
    availableGameTypes: Array<IdEnums.GameType>,
    data: ClubStats
) => availableGameTypes?.includes(selectedGameType) && data?.goalies?.length > 0 && data?.skaters?.length > 0;
